<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <div class="w-full max-w-5xl mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody> Document types </BaseCardBody>
        <BaseCardBody clear-padding>
          <div class="divide-y divide-gray-200">
            <div>
              <div class="bg-gray-50 flex">
                <div
                  class="flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Name
                </div>
                <div
                  class="w-64 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Document Type
                </div>
                <div
                  class="w-40 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Series
                </div>
                <div
                  class="w-40 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Follows Document Series
                </div>
                <div class="w-40 px-6 py-3" />
              </div>
            </div>
            <div>
              <DocumentTypeCreateForm
                :key="documentTypes.length + 1"
                :soft-one-service-id="thirdPartyServiceId"
                :disabled="lockCreate"
              />
            </div>
            <div>
              <DocumentTypeUpdateForm
                :soft-one-service-id="thirdPartyServiceId"
                :initial-data="documentTypes"
                @updating="lockCreate = true"
                @updated="lockCreate = false"
              />
            </div>
          </div>
        </BaseCardBody>
        <BaseCardBody>
          <BaseButton primary @click="$refs.modal.close()"> Close </BaseButton>
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import DocumentTypeCreateForm from './DocumentTypeCreateForm.vue';
import DocumentTypeUpdateForm from './DocumentTypeUpdateForm.vue';

export default {
  components: {
    DocumentTypeCreateForm,
    DocumentTypeUpdateForm,
  },
  props: {
    thirdPartyServiceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lockCreate: false,
    };
  },
  computed: {
    thirdPartyService() {
      return this.$store.state.entities.thirdPartyServices.byId[this.thirdPartyServiceId] || null;
    },
    documentTypes() {
      return this.thirdPartyService?.config?.documentTypes || [];
    },
  },
};
</script>
